export default __webpack_public_path__ + "static/media/profile-img.ec967144.jpg";